import React, { useState } from 'react';
import { Container, Box, Button, TextField, Typography, CircularProgress } from '@mui/material';
import { primaryColor } from '../theme';
import axios from 'axios';
import * as XLSX from 'xlsx';

const BulkAddUsers = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Please select a file to upload');
      return;
    }

    setLoading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('file', file);

    try {
      const userId = JSON.parse(localStorage.getItem('user')).id;
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/bulk-create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'user-id': userId
        }
      });
      setMessage(response.data.msg);
    } catch (error) {
    //   setMessage('Error uploading file');
      setMessage(error.response.data.msg);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = () => {
    const userId = JSON.parse(localStorage.getItem('user')).id;
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_BASE_URL}/download-template?userId=${userId}`; // Path to the static file
    link.download = 'UserTemplate.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
    <Box>
      <Typography variant="h4" gutterBottom style={{ color: primaryColor }}>
        Bulk Add Users
      </Typography>
      <Button variant="contained" color="primary" onClick={handleDownloadTemplate} sx={{ mb: 2 }}>
        Download Template
      </Button>
      <Box>
      </Box>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
      <Button variant="contained" color="primary" onClick={handleUpload} disabled={loading}>
        {loading ? <CircularProgress size={24} /> : 'Upload'}
      </Button>
      {message && <Typography variant="body1" color="textSecondary">{message}</Typography>}
    </Box>
    </Container>
    
  );
};

export default BulkAddUsers;